import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

import { useStyles } from "./Styles";

const propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.object,
};

const FieldWrapper = React.memo(({ title, label, children }) => {
  const styles = useStyles();
  return (
    <Grid container direction="row" alignItems="start" justifyContent="center">
      <Grid item xs={12} pb={2}>
        <Typography variant="h5" color="#1a247e" fontWeight="600">
          {title}
        </Typography>
      </Grid>

      {label && (
        <Grid item xs={12}>
          <div className={styles.label}>{label}</div>
        </Grid>
      )}

      {children && (
        <Grid item xs={12}>
          {children}
        </Grid>
      )}
    </Grid>
  );
});
FieldWrapper.prototype = propTypes;
export default FieldWrapper;
